/**
 * LocalStorage key constants
 * Centralized storage keys to avoid hardcoded strings and prevent typos
 */

export const STORAGE_KEYS = {
  SIDEBAR_COLLAPSED: 'sidebar-collapsed',
  SIDEBAR_PINNED: 'sidebar-pinned',
  THEME: 'theme',
  SELECTED_ORGANIZATION_ID: 'selected_organization_id',
  // Add more storage keys as needed
} as const;
